import axiosInstance from "./../../utils/axiosInstance";
import { buildQueryParams } from './../../services/utility';

const getUsers = async (params) => {
  const queryString = buildQueryParams(params);
  const response = await axiosInstance.get(`user?${queryString}`);
  return response.data.data;
};

const getUser = async (params) => {
  const response = await axiosInstance.get(`user/${params}`);
  return response.data.data;
};

const updateUsersStatus = async (params) => {
  const response = await axiosInstance.put(`user/${params.id}`, params.data);
  return response.data.data;
};

const deleteUsers = async (id) => {
  const response = await axiosInstance.put(`user/delete/${id}`,);
  return response.data.data;
};

const getDashboardData = async () => {
  const startDate = new Date();
  startDate.setHours(0, 0, 0, 0);
  
  const endDate = new Date();
  endDate.setHours(23, 59, 59, 999);
  
  const utcStartDate = startDate.toISOString();
  const utcEndDate = endDate.toISOString();

  const response = await axiosInstance.get(`user/dashboard?start_date=${utcStartDate}&end_date=${utcEndDate}`);
  return response.data.data;
};

const updateUser = async (params) => {
  const response = await axiosInstance.put(`user/${params.id}`, params.data);
  return response.data.data;
};

const deleteUsersImage = async (params) => {
  const response = await axiosInstance.put(`user/${params.id}/image`, params.data);
  return response.data.data;
};

const customerService = {
  getUsers,
  updateUsersStatus,
  getDashboardData,
  getUser,
  deleteUsers,
  updateUser,
  deleteUsersImage,
};

export default customerService;
